<template>
  <el-card class="box-card full-screen cash-record-statistics">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <!-- <el-form-item :label="$t('创建机构')">
          <el-input v-model="queryForm.amount" size="small" />
        </el-form-item>
        <el-form-item :label="$t('创建人')">
          <el-input v-model="queryForm.amount" size="small" />
        </el-form-item>
        <el-form-item :label="$t('收款机构')">
          <el-input v-model="queryForm.amount" size="small" />
        </el-form-item>
        <el-form-item :label="$t('收款人')">
          <el-input v-model="queryForm.amount" size="small" />
        </el-form-item> -->
        <el-form-item :label="$t('amount')">
          <el-input v-model="queryForm.amount" size="small" />
        </el-form-item>
        <el-form-item :label="$t('creationTime')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          />
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-select v-model="queryForm.status" size="small">
            <el-option value="" :label="$t('all')"></el-option>
            <el-option value="0" :label="$t('to be confirmed')"></el-option>
            <el-option value="1" :label="$t('Confirmed received')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('orgOrigin')">
          <el-select
            v-model="queryForm.createOrgInfoId"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option
              v-for="(t, i) in orgList"
              :key="i"
              :label="t.name + ' -- ' + t.orgInfoCode"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('orgDestination')">
          <el-select
            v-model="queryForm.getOrgInfoId"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option
              v-for="(t, i) in orgList"
              :key="i"
              :label="t.name + ' -- ' + t.orgInfoCode"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="btnStatus.isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-row class="table-btns" v-if="loginInfo.orgType != 1">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="addRecordVisible()"
          >{{ $t("add cashLending") }}</el-button
        >
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="addAccountLendingVisible()"
          >{{ $t("accountLending") }}</el-button
        >
      </el-row>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="table.records"
        v-loading="btnStatus.isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="createOrgName"
          :label="$t('orgCreated')"
          min-width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.createOrgName }} ({{ scope.row.createOrgInfoCode }})
          </template>
        </el-table-column>
        <el-table-column
          prop="createName"
          :label="$t('creator')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.createName }} {{ scope.row.createSurname }} ({{
              scope.row.createLoginName
            }})
          </template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('amount')" min-width="160">
          <template slot-scope="scope">
            <span class="franc">₣</span> {{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('businessType')"
          min-width="130"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0" class="text-primary">{{
              $t("cashLend")
            }}</span>
            <span v-else class="text-success">{{ $t("accountLend") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="receiveOrg"
          :label="$t('Payee org')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.getOrgName && scope.row.getOrgInfoCode">
              {{ scope.row.getOrgName }} ({{ scope.row.getOrgInfoCode }})
            </span>
            <span v-else class="escrow-tag">
              <el-tag type="warning" size="small">{{
                $t("escrowAccount")
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="receiveMember"
          :label="$t('Payee')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.getName"
              >{{ scope.row.getName }} {{ scope.row.getSurname }} ({{
                scope.row.getLoginName
              }})</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-warning">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 3" class="text-danger">{{
              $t("notApproved")
            }}</span>
            <span v-if="scope.row.status == 4" class="text-danger">{{
              $t("Cancelled")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-primary">{{
              $t("to be confirmed")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-success">{{
              $t("Confirmed received")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.createTime).format("ymdhms") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="affirmTime"
          :label="$t('acknowledging time')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.affirmTime">{{
              $manba(scope.row.affirmTime).format("ymdhms")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('extend')"
          width="250"
          v-if="loginInfo.orgType != 1"
        >
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.status==0&&scope.row.getOrgInfoId!=loginInfo.orgInfoId" size="mini" disabled type="primary">{{$t('checkPending')}}</el-button> -->
            <el-button
              v-if="
                scope.row.status == 1 &&
                  scope.row.getOrgInfoId != loginInfo.orgInfoId
              "
              size="mini"
              disabled
              type="primary"
              >{{ $t("to be confirmed") }}</el-button
            >
            <el-button
              v-else-if="scope.row.status == 1"
              size="mini"
              @click="updateStatus(scope.row)"
              type="primary"
              >{{ $t("in receipt of") }}</el-button
            >

            <el-button
              v-if="scope.row.status == 4"
              size="mini"
              disabled
              type="danger"
              >{{ $t("cancel") }}</el-button
            >

            <el-button
              v-if="
                scope.row.status == 0 &&
                  scope.row.createOrgInfoId === loginInfo.orgInfoId
              "
              size="mini"
              @click="editRecord(scope.row)"
              type="primary"
              >{{ $t("edit") }}
            </el-button>

            <el-button
              v-if="
                scope.row.status == 0 &&
                  scope.row.createOrgInfoId === loginInfo.orgInfoId
              "
              size="mini"
              @click="cancelRecord(scope.row)"
              type="danger"
              >{{ $t("cancel") }}
            </el-button>

            <el-button v-else size="mini" disabled type="primary">{{
              $t("in receipt of")
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('extend')"
          width="120"
          v-if="loginInfo.orgType == 1"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              type="primary"
              size="mini"
              @click="openCheckApply(scope.row)"
              >{{ $t("check") }}</el-button
            >

            <el-button v-else size="mini" disabled>{{ $t("check") }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="table.total"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(addForm.type === 3 ? 'accountLending' : 'cashLending')"
      :visible.sync="isVisible"
      :size="420"
      direction="rtl"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
    >
      <el-form :model="addForm" :rules="rules" ref="addForm">
        <el-form-item
          :label="$t('destinationType')"
          prop="destinationType"
          v-if="addForm.type === 3"
        >
          <el-radio-group v-model="addForm.destinationType">
            <el-radio :label="1">{{ $t("operateOrg") }}</el-radio>
            <el-radio :label="2">{{ $t("escrowAccount") }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          v-if="addForm.type === 3 && addForm.destinationType === 1"
          :label="$t('Payee org')"
          prop="orgInfoId"
        >
          <el-select v-model="addForm.orgInfoId" filterable>
            <el-option
              v-for="(t, i) in orgList"
              :key="i"
              :label="t.name + ' -- ' + t.orgInfoCode"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="addForm.type === 0"
          :label="$t('Payee org')"
          prop="orgInfoId"
        >
          <el-select v-model="addForm.orgInfoId" filterable>
            <el-option
              v-for="(t, i) in orgList"
              :key="i"
              :label="t.name + ' -- ' + t.orgInfoCode"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="addForm.type === 3 && addForm.destinationType === 2"
          :label="$t('escrowAccount')"
        >
          <el-input
            v-model="escrowAccountInfo"
            disabled
            :placeholder="$t('escrowAccount')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('amount')" prop="amount">
          <el-input
            type="number"
            size="medium"
            v-model="addForm.amount"
            maxlength="7"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('remark')">
          <el-input type="textarea" size="medium" v-model="addForm.remark" />
        </el-form-item>
        <div class="bottom-button">
          <el-button
            v-if="addForm.id"
            size="medium"
            type="primary"
            @click="updateSubmit('addForm')"
            :loading="btnStatus.isLoading"
            >{{ $t("submit") }}</el-button
          >
          <el-button
            v-else
            size="medium"
            type="primary"
            :loading="btnStatus.isLoading"
            @click="onSubmit('addForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>

    <!-- Check form-->
    <el-drawer
      :title="$t(checkForm.type === 0 ? 'cashLending' : 'accountLending')"
      :visible.sync="checkDrawer"
      direction="rtl"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="500"
    >
      <el-form :model="checkForm" :rules="rules2" ref="checkForm">
        <el-form-item prop="id" style="display: none;">
          <el-input size="medium" v-model="checkForm.id" />
        </el-form-item>
        <el-form-item>
          <el-input size="medium" v-model="checkForm.receiveOrg" disabled />
        </el-form-item>
        <el-form-item :label="$t('amount')">
          <el-input
            type="number"
            size="medium"
            v-model="addForm.amount"
            maxlength="7"
            disabled=""
          />
        </el-form-item>

        <el-form-item v-if="checkForm.type === 1" :label="$t('businessType')">
          <el-input size="medium" :value="$t('accountLending')" disabled />
        </el-form-item>
        <el-form-item v-if="checkForm.type === 0" :label="$t('businessType')">
          <el-input size="medium" :value="$t('cashLending')" disabled />
        </el-form-item>

        <el-form-item :label="$t('applayRemark')">
          <el-input
            type="textarea"
            :rows="3"
            size="medium"
            v-model="addForm.remark"
            disabled
          ></el-input>
        </el-form-item>

        <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
        <el-form-item :label="$t('status')" prop="status">
          <el-select v-model="checkForm.status">
            <el-option :value="1" :label="$t('getApproved')"></el-option>
            <el-option :value="3" :label="$t('notApproved')"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('remark')" prop="verifyRemark">
          <el-input
            type="textarea"
            :rows="3"
            size="medium"
            v-model="checkForm.verifyRemark"
          ></el-input>
        </el-form-item>

        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="btnStatus.isLoading"
            @click="onSubmitCheck('checkForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import card from "@/api/card";
import org from "@/api/org";

export default {
  data() {
    return {
      //table高度，动态设置
      queryTableHeight: String,
      queryForm: {},
      checkForm: {},
      orgList: [],
      checkDrawer: false,

      btnStatus: { isLoading: false },
      table: {
        records: [
          {
            createOrg: "长虹（100000）",
            createMember: "张三(1000)",
            receiveOrg: "海尔（200000）",
            receiveMember: "",
            amount: "600000",
            status: 1,
            createTime: "2021-07-11 12:21:18",
            statusTime: undefined,
          },
          {
            createOrg: "海尔（200000）",
            createMember: "李四(2000)",
            receiveOrg: "长虹（100000）",
            receiveMember: "",
            amount: "150000",
            status: 1,
            createTime: "2021-07-01 15:21:18",
            statusTime: undefined,
          },
          {
            createOrg: "长虹（100000）",
            createMember: "张三(1000)",
            receiveOrg: "海尔（200000）",
            receiveMember: "李四(2000)",
            amount: "50000",
            status: 2,
            createTime: "2021-06-21 07:21:18",
            statusTime: "2021-07-11 07:40:28",
          },
        ],
      },
      pageSize: 20,
      currentPage: 1,

      isVisible: false,

      addForm: {
        type: null,
        destinationType: null,
      },

      //禁用今天之后的日期选项
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //选当前时间之前的时间
        },
      },
      //禁用今天之后的日期选项
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: (time) => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    rules() {
      return {
        destinationType: [
          {
            required: true,
            message: this.$t("pleaseSelectDestination"),
            trigger: "change",
          },
        ],
        orgInfoId: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
    rules2() {
      return {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    },
  },
  methods: {
    getOrgList() {
      let _this = this;
      org.getOrgListOnly({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) {
            _this.orgList = res.data.records;
          } else {
            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });
    },
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: (time) => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          },
        };
      }
    },
    getList() {
      let _this = this;
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));

      // Process date range
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      }
      // Remove date field
      delete params.date;

      card.pageCashLending({
        param: {
          current: _this.table.currentPage,
          size: _this.table.pageSize,
          ...params,
        },
        success: (res) => {
          _this.table = res.data || {};
        },
      });
      _this.isLoading = false;
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    addRecordVisible() {
      this.addForm = {
        type: 0, // Cash Lending
        destinationType: null,
      };

      this.isVisible = true;
    },
    addAccountLendingVisible() {
      this.addForm = {
        type: 3, // Account Lending
        destinationType: null,
      };
      this.isVisible = true;
    },

    editRecord(row) {
      let _this = this;

      if (row.type === 0) {
        // Cash Lending
        _this.addForm = {
          id: row.id,
          type: 0,
          destinationType: null,
          orgInfoId: row.getOrgInfoId,
          amount: row.amount,
          remark: row.remark,
          createOrgInfoId: row.createOrgInfoId,
          createOrgId: row.createOrgId,
        };
      } else if (row.type === 1) {
        _this.addForm = {
          id: row.id,
          type: 3,
          destinationType: 1,
          orgInfoId: row.getOrgInfoId,
          amount: row.amount,
          remark: row.remark,
          createOrgInfoId: row.createOrgInfoId,
          createOrgId: row.createOrgId,
        };
      } else if (row.type === 2) {
        _this.addForm = {
          id: row.id,
          type: 3,
          destinationType: 2,
          orgInfoId: null, // No org for escrow
          amount: row.amount,
          remark: row.remark,
          createOrgInfoId: row.createOrgInfoId,
          createOrgId: row.createOrgId,
        };
      }

      _this.isVisible = true;
    },

    cancelRecord(row) {
      let _this = this;

      this.$confirm(this.$t("confirmCancelLending"), this.$t("warning"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      })
        .then(() => {
          _this.btnStatus.isLoading = true;

          card.updateCashLendingStatus({
            param: {
              id: row.id,
              status: 4, // 4 = Cancelled
              type: row.type,
            },
            success: (res) => {
              if (res.code == 200) {
                _this.getList();
                _this.$message.success(_this.$t("operateSuccessfully"));
              } else {
                _this.$message.warning(_this.$t(res.msg));
              }
              _this.btnStatus.isLoading = false;
            },
            error: () => {
              _this.btnStatus.isLoading = false;
            },
          });
        })
        .catch(() => {
          // User cancelled the confirmation
          _this.$message.info(_this.$t("operationCancelled"));
        });
    },

    openCheckApply(row) {
      this.addForm = row;
      this.checkForm = {
        //receiveOrg: row.getOrgName + " (" + row.getOrgInfoCode + ")",
        receiveOrg: row.getOrgName
          ? `${row.getOrgName} (${row.getOrgInfoCode})`
          : this.$t("escrowAccount"),
        type: row.type,
        id: row.id,
      };
      this.checkDrawer = true;
    },
    onSubmit(refName) {
      let _this = this;

      this.$refs[refName].validate((valid) => {
        if (!valid) return false;

        _this.btnStatus.isLoading = true;

        let submitData = { ..._this.addForm };
        if (submitData.type === 3) {
          if (submitData.destinationType === 2) {
            submitData.type = 2; // Escrow
          } else {
            submitData.type = 1; // Organization
          }
        }

        card.addCashLending({
          param: submitData,
          success: (res) => {
            if (res.code == 200) {
              _this.isVisible = false;
              _this.getList();
              _this.btnStatus.isLoading = false;
              _this.$message.success(_this.$t("operateSuccessfully"));
            } else {
              _this.$message.warning(_this.$t(res.msg));
              _this.btnStatus.isLoading = false;
            }
          },
        });
        _this.btnStatus.isLoading = false;
      });
    },

    //
    updateSubmit(refName) {
      let _this = this;

      this.$refs[refName].validate((valid) => {
        if (!valid) return false;

        _this.btnStatus.isLoading = true;

        let submitData = { ..._this.addForm };

        if (submitData.type === 3) {
          if (submitData.destinationType === 2) {
            submitData.type = 2; // Escrow
          } else {
            submitData.type = 1; // Organization
          }
        }

        card.updateCashLending({
          param: submitData,
          success: (res) => {
            if (res.code == 200) {
              _this.isVisible = false;
              _this.getList();
              _this.btnStatus.isLoading = false;
              _this.$message.success(_this.$t("operateSuccessfully"));
            } else {
              _this.$message.warning(_this.$t(res.msg));
              _this.btnStatus.isLoading = false;
            }
          },
        });
        _this.btnStatus.isLoading = false;
      });
    },

    //onSubmitCheck
    onSubmitCheck(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        card.cashLendingCheck({
          param: _this[refName],
          success: (res) => {
            if (res.code == 200) {
              //_this.isVisible = false;
              this.checkDrawer = false;
              _this.getList();
              _this.$message.success(_this.$t("operateSuccessfully"));
            } else {
              _this.$message.warning(_this.$t(res.msg));
            }
          },
        });
      });
    },
    updateStatus(row) {
      let _this = this;
      card.updateCashLendingStatus({
        param: { id: row.id, status: 2, type: row.type },
        success: (res) => {
          if (res.code == 200) {
            _this.getList();
            _this.$message.success(_this.$t("operateSuccessfully"));
          } else {
            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";

    this.getList();

    this.getOrgList();
    //console.log("Data : ", this.getOrgList());
  },
};
</script>

<style lang="less" scoped></style>
